import { render, staticRenderFns } from "./IconMotivator.vue?vue&type=template&id=d3a42d64"
import script from "./IconMotivator.vue?vue&type=script&lang=js"
export * from "./IconMotivator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports